import api_meter_health_check from "../../api/api_meter_health_check.js";
import axios from "axios";
import { CSRF_TOKEN } from "../../common/csrf_token.js";

const state = {
  meterHealthCheckData: null,
  meterHealthCheckCriticalIssues: null,
  meterHealthCheckFunctioningMeters: null,
  meterHealthCheckPotentialIssues: null,
  meterHealthCheckGraphData: null,
  meterHealthCheckList: null,
  meterHealthCheckDashboards: null,
  meterHealthCheckHeatmap: null,
};


const getters = {
  getMeterHealthCheckData: state => state.meterHealthCheckData,
  getMeterHealthCheckCriticalIssues: state => state.meterHealthCheckCriticalIssues,
  getMeterHealthCheckFunctioningMeters: state => state.meterHealthCheckFunctioningMeters,
  getMeterHealthCheckPotentialIssues: state => state.meterHealthCheckPotentialIssues,
  getMeterHealthCheckGraphData: state => state.meterHealthCheckGraphData,
  getMeterHealthCheckList: state => state.meterHealthCheckList,
  getMeterHealthCheckDashboards: state => state.meterHealthCheckDashboards,
  getMeterHealthCheckHeatmap: state => state.meterHealthCheckHeatmap,
};


const actions = {
  async fetchMeterHealthCheckList({ commit }) {
    const response = await api_meter_health_check.meterHealthCheckList();
    if (!response)  {
      commit("setFormError", "Something went wrong. Try again later");
      setTimeout(() => document.getElementById("formError").style.display = "none", 5000);
    }
    else {
      commit('setMeterHealthCheckList', response.sites);
    }
  },
  async fetchMeterHealthCheckDashboards({ commit }) {
    const response = await api_meter_health_check.meterHealthCheckDashboards();
    if (!response)  {
      commit("setFormError", "Something went wrong. Try again later");
      setTimeout(() => document.getElementById("formError").style.display = "none", 5000);
    }
    else {
      commit('setMeterHealthCheckDashboards', response.queryset);
    }
  },
  async performExecuteMeterHealthCheckQuery({commit}, payload) {
    commit("setLoader", true);
    commit("setFormError", null);
    const response = await api_meter_health_check.executeMeterHealthCheckQuery(payload);
    if (!response)  {
      commit("setFormError", "Something went wrong. Try again later")
      commit("setLoader", false);
    } else {
       if (!response.error) {
          commit("setMeterHealthCheckData", response.meter_health_check_data);
          commit("setMeterHealthCheckCriticalIssues", response.critical_issues);
          commit("setMeterHealthCheckFunctioningMeters", response.functioning_meters);
          commit("setMeterHealthCheckPotentialIssues", response.potential_issues);
          commit("setMeterHealthCheckHeatmap", response.heatmap);
          var meterHealthCheckBarGraphDataset = {
            labels: response.bar_chart_data[0],
            datasets: [
              {
                label: 'Working',
                backgroundColor: '#287E8F',
                data: response.bar_chart_data[1],
              },
              {
                label: 'Zero',
                backgroundColor: '#F6B53D',
                data: response.bar_chart_data[2]
              },
              {
                label: 'No Data',
                backgroundColor: '#E85E76',
                data: response.bar_chart_data[3]
              },
            ]
          };

          commit("setMeterHealthCheckBarGraphData", meterHealthCheckBarGraphDataset);
          commit("setLoader", false);
          commit("setFormError", null);
       } else {
          commit("setLoader", false);
          commit("setFormError", response.error)
       }
    }
  },
  async performDownloadMeterHealthCheckExcelQuery({ commit }, payload) {
      try {
         commit("setLoader", true);
         commit("setFormError", null);

        // Make POST request to the Django endpoint for CSV download
        const response = await axios.post('/api/download-missing-timestamps/', payload, {
          headers: {
            'X-CSRFToken': CSRF_TOKEN,
          },
          responseType: 'blob', // Expect binary data (CSV)
        });

        // Create a new Blob object using the response data
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Create a link element for download
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        // Set the download attribute to specify the filename
        link.download = `dataset.xlsx`;

        // Trigger the download by clicking the link
        link.click();

        commit("setLoader", false);

      } catch (error) {
        console.error('Error generating Excel:', error);
        commit("setLoader", false);
        commit("setFormError", "Submit a ticket with the following error message - " + error.message);

        // Hide the error message after 5 seconds
        setTimeout(() => {
          const errorElement = document.getElementById("formError");
          if (errorElement) {
            errorElement.style.display = "none";
          }
        }, 5000);
      }
    },
};

const mutations = {
  setMeterHealthCheckData: (state, meterHealthCheckData) => {
    state.meterHealthCheckData = meterHealthCheckData
  },
  setMeterHealthCheckCriticalIssues: (state, meterHealthCheckCriticalIssues) => {
    state.meterHealthCheckCriticalIssues = meterHealthCheckCriticalIssues
  },
    setMeterHealthCheckFunctioningMeters: (state, meterHealthCheckFunctioningMeters) => {
    state.meterHealthCheckFunctioningMeters = meterHealthCheckFunctioningMeters
  },
    setMeterHealthCheckPotentialIssues: (state, meterHealthCheckPotentialIssues) => {
    state.meterHealthCheckPotentialIssues = meterHealthCheckPotentialIssues
  },
  setMeterHealthCheckBarGraphData: (state, meterHealthCheckGraphData) => {
     state.meterHealthCheckGraphData = meterHealthCheckGraphData
  },
  setMeterHealthCheckList: (state, meterHealthCheckList) => {
    state.meterHealthCheckList = meterHealthCheckList
  },
  setMeterHealthCheckDashboards: (state, meterHealthCheckDashboards) => {
    state.meterHealthCheckDashboards = meterHealthCheckDashboards
  },
  setMeterHealthCheckHeatmap: (state, meterHealthCheckHeatmap) => {
    state.meterHealthCheckHeatmap = meterHealthCheckHeatmap
  },
};



export default {
  state,
  getters,
  actions,
  mutations
}